import { render, staticRenderFns } from "./centralMensagens.vue?vue&type=template&id=6822000c&scoped=true&lang=pug&"
import script from "./centralMensagens.vue?vue&type=script&lang=js&"
export * from "./centralMensagens.vue?vue&type=script&lang=js&"
import style0 from "./centralMensagens.vue?vue&type=style&index=0&id=6822000c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6822000c",
  null
  
)

export default component.exports